import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { OverflowTooltip } from '@components/tooltip/OverflowTooltip';

export type DetailItemProps = {
  label: string;
  value: string | ReactNode | null | undefined;
  suffix?: string | ReactNode | null;
};

export const DetailItem = (props: DetailItemProps) => {
  const { label, value, suffix } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        minWidth: 0,
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          margin: '8px 0',
          minWidth: 0,
          flex: 1,
        }}
      >
        <Typography
          variant='caption'
          sx={{
            color: 'text.subdued',
          }}
        >
          {label}
        </Typography>
        <OverflowTooltip tooltipText={value as string}>
          <Typography
            variant='bodySmall'
            sx={{
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
              lineHeight: 1.4,
            }}
          >
            {value}
          </Typography>
        </OverflowTooltip>
        {suffix && <Box sx={{ pl: 0, '.MuiButtonBase-root': { paddingLeft: 0 } }}>{suffix}</Box>}
      </Box>
    </Box>
  );
};
